<template>
  <div class="platform-features px-10">
    <TypeDisplay
      :variant="$options.Typography.Display.TERA"
      :weight="$options.Typography.Weights.STRONG"
      class="font-bold block text-center"
    >
      Platform Features
    </TypeDisplay>
    <FeatureImageText
      v-for="(feature, index) in features"
      :key="`feature-${index}`"
      v-bind="feature"
      :reverse="!!(index % 2)"
      class="mt-28"
    />
  </div>
</template>

<script>
import get from 'lodash/get';
import {
  computed,
  defineComponent,
  ref,
  useFetch,
} from '@nuxtjs/composition-api';
import { constants, TypeDisplay } from '@bambeehr/pollen';
import FeatureImageText from '@/modules/InformationPages/Product/components/FeatureImageText';
import Contentful from '@/services/Contentful';
import ContentfulEntryIDs from '@/lib/global/ContentfulEntryIDs';

const { Typography } = constants;

export default defineComponent({
  name: 'PlatformFeatures',
  Typography,
  components: { FeatureImageText, TypeDisplay },
  setup() {
    const content = ref({});
    const isLoading = ref(true);
    const { fetch } = useFetch(async () => {
      content.value = await Contentful.getEntry(
        ContentfulEntryIDs.PLATFORM_FEATURES
      );

      isLoading.value = false;
    });

    fetch();

    const features = computed(() => {
      const items = get(content.value, 'fields.sections', []);

      return items
        .map((item) => {
          const imageUrl = get(item, 'fields.image.fields.file.url');
          const title = get(item, 'fields.title');
          const subtitle = get(item, 'fields.description');

          return {
            image: imageUrl ? `https:${imageUrl}` : null,
            title,
            subtitle,
          };
        })
        .filter((item) => item.image);
    });

    return {
      content,
      features,
    };
  },
});
</script>
